module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921021149_T.558700c8.jpg";